export const strings = {
  comment: 'Yorum',
  reply: 'Cevap vermek',
  share: 'Paylaşmak',
  like: 'Beğenmek',
  num_liked: '{num} kişi beğendi',
  num_likes: '{num} Beğeni',
  num_followings: '{num} Takip ediliyor',
  num_comments: '{num} yorum',
  num_replies: '{num} Cevaplar',
  num_like: '{num} gibi',
  num_following: '{num} Takip eden',
  num_comment: '{num} yorum',
  num_reply: '{num} cevap',
  say_something: 'Bir şey söylemek...',
  write_comment: 'Yorum yaz',
  save_changes: 'Değişiklikleri Kaydet',
  add_reply: 'Bir cevap ekle',
  upload_photo: 'Bir Fotoğraf Yükle',
  upload_video: 'Bir Video Yükle',
  attach_file: 'Bir Dosya Ekle',
  post: 'Postalamak',
  posting: 'Gönderi',
  load_more: 'Daha Fazlasını Yükle',
  more: 'Daha',
  less: 'Az',
  post_feed: 'Bir besleme yayınla',
  edit_feed: 'Beslemeyi düzenle',
  edit_post: 'Gönderiyi Düzenle',
  delete_post: 'Gönderiyi Sil',
  edit_comment: 'Yorumu Düzenle',
  delete_comment: 'Yorumu Sil',
  edit_reply: 'Düzenlemek',
  delete_reply: 'Silmek',
  delete_replyy: 'Cevabı Sil',
  cancel: 'İptal etmek',
  update: 'Güncelleme',
  author: 'Yazar',
  num_view: '{num} görünüm',
  num_views: '{num} görüntüleme',
  write_articles: 'Makale Yaz',
  publish_case: 'Davayı Yayımla',
  create_poll: 'Anket Oluştur',
  microsite_post_msg: 'Bu Mikrositedeki herkes gönderilerinizi görebilir',
  download: 'İndirmek',
  download_media: 'Tüm Medyayı İndir',
  fetching: 'Getiriliyor...',
  no_preview: 'Önizleme mevcut değil',
  delete_comment_confirmation: 'Yorumu silmek istediğinizden emin misiniz?',
  share_post: 'Gönderiyi Paylaş',
  close: 'Kapalı',
  influencer: 'Etkileyici',
  hide_post: 'Gönderiyi Gizle',
  unhide_post: 'Gönderiyi Gizle',
  hide_post_string: 'Gönderiyi gizlemek istediğinizden emin misiniz?',
  unhide_post_string: 'Gönderiyi gizlemek istediğinizden emin misiniz?',
  pin_post: 'Pin Gönderisi',
  unpin_post: 'Gönderiyi Sabitlemeyi Kaldır',
  pin_post_string: 'Gönderiyi sabitlemek istediğinizden emin misiniz?',
  unpin_post_string: 'Gönderiyi sabitlemeyi kaldırmak istediğinizden emin misiniz?',
  verifiedError: ' Tıbbi lisansınız doğrulanana kadar platforma erişiminizin sınırlı olacağını lütfen unutmayın.',
  hide_poll: 'Anketi Gizle',
  unhide_poll: 'Anketi Gizle',
  hide_poll_string: 'Anketi gizlemek istediğinizden emin misiniz?',
  unhide_poll_string: 'Anketi gizlemek istediğinizden emin misiniz?',
  pin_poll: 'Pin Anketi',
  unpin_poll: 'Anketi Sabitle',
  pin_poll_string: 'Anketi sabitlemek istediğinizden emin misiniz?',
  unpin_poll_string: 'Anketi sabitlemeyi kaldırmak istediğinizden emin misiniz?',
  pin_poll_tooltop: 'Bu anket sabitlendi',
  hide_poll_tooltop: 'Bu anket gizli',

  pin_post_tooltop: 'Bu gönderi sabitlendi',
  hide_post_tooltop: 'Bu gönderi gizli',

  edit: {
    post: 'Gönderiyi Düzenle',
    poll: 'Anketi Düzenle',
    blog: 'Makaleyi Düzenle',
    case: 'Davayı Düzenle',
  },
  delete: {
    post: 'Gönderiyi Sil',
    poll: 'Anketi Sil',
    blog: 'Makaleyi Sil',
    case: 'Büyük/Küçük Harfleri Sil',
    webinar: 'Webinar\'ı Sil',
  },
  delete_desc: {
    post: 'Bu Gönderiyi silmek istediğinizden emin misiniz?',
    poll: 'Bu Anketi silmek istediğinizden emin misiniz?',
    blog: 'Bu Makaleyi silmek istediğinizden emin misiniz?',
    case: 'Bu Davayı silmek istediğinizden emin misiniz?',
    webinar: 'Bu web seminerini silmek istediğinizden emin misiniz?',
  },
  hide: {
    post: 'Gönderiyi Gizle',
    poll: 'Anketi Gizle',
    blog: 'Makaleyi Gizle',
    case: 'Davayı Gizle',
  },
  hide_desc: {
    post: 'Bu Gönderiyi gizlemek istediğinizden emin misiniz?',
    poll: 'Bu Anketi gizlemek istediğinizden emin misiniz?',
    blog: 'Bu Makaleyi gizlemek istediğinizden emin misiniz?',
    case: 'Bu Vakayı gizlemek istediğinizden emin misiniz?',
  },
  unhide: {
    post: 'Gönderiyi Gizle',
    poll: 'Anketi Gizle',
    blog: 'Makaleyi Gizle',
    case: 'Davayı Göster',
  },
  unhide_desc: {
    post: 'Bu Gönderiyi göstermek istediğinizden emin misiniz?',
    poll: 'Bu Anketi göstermek istediğinizden emin misiniz?',
    blog: 'Bu Makaleyi gerçekten göstermek istiyor musunuz?',
    case: 'Bu Davayı gerçekten göstermek istiyor musunuz?',
  },
  pin: {
    post: 'Pin Gönderisi',
    poll: 'Pin Anketi',
    blog: 'Makaleyi sabitle',
    case: 'Pin Kutusu',
  },
  pin_desc: {
    post: 'Bu Gönderiyi sabitlemek istediğinize emin misiniz?',
    poll: 'Bu Anketi sabitlemek istediğinizden emin misiniz?',
    blog: 'Bu Makaleyi sabitlemek istediğinizden emin misiniz?',
    case: 'Bu Davayı sabitlemek istediğinizden emin misiniz?',
  },
  unpin: {
    post: 'Gönderiyi Sabitlemeyi Kaldır',
    poll: 'Anketi Sabitle',
    blog: 'Makaleyi Sabitle',
    case: 'Davayı Çöz',
  },
  unpin_desc: {
    post: 'Bu Gönderiyi sabitlemeyi kaldırmak istediğinizden emin misiniz?',
    poll: 'Bu Anketi sabitlemeyi kaldırmak istediğinizden emin misiniz?',
    blog: 'Bu Makaleyi sabitlemeyi kaldırmak istediğinizden emin misiniz?',
    case: 'Bu Davayı sabitlemeyi kaldırmak istediğinizden emin misiniz?',
  },
  pin_tooltip: {
    post: 'Bu gönderi sabitlendi',
    poll: 'Bu anket sabitlendi',
    blog: 'Bu blog sabitlendi',
    case: 'Bu dava sabitlendi',
  },
  hide_tooltip: {
    post: 'Bu gönderi gizli',
    poll: 'Bu anket gizli',
    blog: 'Bu blog gizli',
    case: 'Bu dava gizli',
  },
  hide_comment: 'Yorumu Gizle',
  unhide_comment: 'Yorumu Gizle',
  hide_comment_string: 'Yorumu gizlemek istediğinizden emin misiniz?',
  unhide_comment_string: 'Yorumu gizlemek istediğinizden emin misiniz?',
  hide_comment_tooltop: 'Bu yorum gizli',
  hide_reply: 'Cevabı Gizle',
  unhide_reply: 'Cevabı Gizle',
  hide_reply_string: 'Cevabı gizlemek istediğinizden emin misiniz?',
  unhide_reply_string: 'Cevabı gizlemek istediğinizden emin misiniz?',
  hide_reply_tooltop: 'Bu cevap gizli',
  upload_poll: 'Bir Anket Yükle',
  delete_poll: 'Anketi Sil',
  delete_poll_confirmation: 'Anketi silmek istediğinizden emin misiniz?',
  delete_post_confirmation: 'Gönderiyi silmek istediğinizden emin misiniz?',
  edit_poll: 'Anketi Düzenle',
  post_poll: 'Bir Anket Gönder',
  submit: 'Göndermek',
  no_poll: 'Anket Yok',
  multiselect_option: 'Kullanıcı birden fazla seçeneği seçebilir',
  max_options: 'Maksimum Seçenekler',
  remove_poll: 'Anketi Kaldır',
  enter_date: 'Son kullanma tarihini girin',
  poll_type: 'Anket Türü',
  show_results_after: 'Sonuçları Göster Sonra',
  ask_question: 'Bir soru sor',
  enter_choice: 'Seçimi Girin ',
  choice: 'Seçenek ',
  votes_result: ' oylar • ',
  poll_create: 'Anket Oluştur ',
  vote: 'Oy',
  no_video: 'Video yok',
  post_comment: 'Postalamak',
  post_reply: 'Postalamak',
  reject_comment_title: 'Bu yorum şu nedenle reddedildi',
  edit_replyy: 'Cevabı Düzenle',
  expert: 'Uzman',
  comment_disclaimer:
    'Lütfen hasta gizliliğinin ihlal edilmediğinden emin olun.',
  add_attachment: ' Ek Ekle',
  uploading: 'yükleniyor...',
};